Ext.ns('mx.comp');

mx.comp.LinkedLovCombo = Ext.extend(Ext.ux.form.LovCombo, {
    hideOnSelect: false,
    maxHeight: 200,
    valueField: 'id',
    lazyInit: false,
    triggerAction: 'all',
    displayField: 'name',
    forbidEditingMode: true,
    editable: false,
    dirty: false,

    initEvents: function() {
        mx.comp.LinkedLovCombo.superclass.initEvents.apply(this, arguments);
        this.el.on('keydown', this.keySearch, this, true);

        this.keyNav.enter = this.keyNav.esc; // collapse on enter
    },

    keySearch: function(e, target, options, donotinit) {
        var thiz = this;

        if (this.store.getCount() == 0 && !donotinit) {
            var checkLetterOnLoad = function() {
                thiz.store.un('load', checkLetterOnLoad);
                thiz.keySearch(e, target, options, true);
            };
            this.store.on('load', checkLetterOnLoad);
            this.store.load();
        }

        var raw = e.getKey();
        var key = String.fromCharCode(raw);
        var startIndex = 0;

        if (!this.store.getCount()) {
            return;
        }

        // todo: support pgup, pgdown, home, end nav
        switch (raw) {
            case Ext.EventObject.HOME:
                e.stopEvent();
                this.selectFirst();
                return;

            case Ext.EventObject.END:
                e.stopEvent();
                this.selectLast();
                return;

            case Ext.EventObject.PAGEDOWN:
                this.selectNextPage();
                e.stopEvent();
                return;

            case Ext.EventObject.PAGEUP:
                this.selectPrevPage();
                e.stopEvent();
                return;
            case Ext.EventObject.SPACE:
                this.onViewClick();
                this.delayedCheck = true;
                this.unsetDelayCheck.defer(10, this);
                return;
        }

        // skip special keys other than the shift key
        if ((e.hasModifier() && !e.shiftKey) || e.isNavKeyPress() || e.isSpecialKey()) {
            return;
        }
        this.search(this.displayField, key, 0);
    },

    search: function(field, value, startIndex) {
        field = field || this.displayField;
        var index = this.store.find.apply(this.store, arguments);
        if (index !== -1) {
            this.focusAndSelect(index);
        }
    },

    selectFirst: function() {
        this.focusAndSelect(this.store.data.first());
    },

    selectLast: function() {
        this.focusAndSelect(this.store.data.last());
    },

    selectPrevPage: function() {
        var index = Math.max(this.selectedIndex - 30, 0);
        this.focusAndSelect(this.store.getAt(index));
    },

    selectNextPage: function() {
        var index = Math.min(this.selectedIndex + 30, this.store.getCount() - 1);
        this.focusAndSelect(this.store.getAt(index));
    },

    focusAndSelect: function(record) {
        var index = typeof record === 'number' ? record : this.store.indexOf(record);
        this.select(index, this.isExpanded());
        this.onSelect(this.store.getAt(index), index, this.isExpanded());
    },

    initComponent: function() {
        this.addEvents('beforestoreload');
        this.on('render', this.initDataView, this);
        mx.comp.LinkedLovCombo.superclass.initComponent.call(this, arguments);
    },

    getValue: function() {
        return this.value || new Array();
    },

    initDataView: function() {
        if (this.view) {
            var parent = this;
            this.view.prepareData = function(data) {
                if (parent.value) {
                    Ext.each(
                        parent.value,
                        function(v) {
                            if (data['id'] == v.get('id')) {
                                data[parent.checkField] = true;
                                return false;
                            }
                        },
                        this
                    );
                }
                return data;
            };
        }
    },

    onLoad: function() {
        this.fireEvent('beforestoreload');
        mx.comp.LinkedLovCombo.superclass.onLoad.call(this, arguments);
    },

    setValue: function(v) {
        if (v) {
            if (Ext.isArray(v)) {
                var thiz = this;
                this.value = v.map(function(v) {
                    return thiz.transformValue(v);
                });
            } else if (v instanceof Ext.data.Record) {
                if (!Ext.isArray(this.value)) {
                    this.value = new Array();
                }
                if (v.get(this.checkField)) {
                    //                    v.data[this.checkField] = true;
                    this.value.push(v);
                } else {
                    //                    v.data[this.checkField] = false;
                    var index = this.value.indexOfUsing(function(value, i, values) {
                        return value.get('id') == v.get('id');
                    });
                    if (index != -1) {
                        this.value.splice(index, 1);
                    }
                }
            }
            var displayValue = this.getCheckedDisplay();
            if (this.el) {
                this.setRawValue(displayValue);
            }
            if (this.hiddenField) {
                this.hiddenField.value = this.value;
            }
            if (this.el) {
                this.el.removeClass(this.emptyClass);
            }
            if (displayValue == '') {
                this.clearValue();
            }
            if (this.view) {
                this.view.all.clear();
            }
        } else {
            this.clearValue();
        }
    },

    refreshValue: function() {
        this.value = this.getCheckedValue();
        var displayValue = this.getCheckedDisplay();
        if (this.el) {
            this.setRawValue(displayValue);
        }
    },

    getCheckedValue: function() {
        var snapshot = this.store.snapshot || this.store.data;

        var result = new Array();

        snapshot.each(function(r) {
            if (r.get(this.checkField)) {
                result.push(r);
            }
        }, this);

        return result;
    },

    getCheckedDisplay: function() {
        var displayValue = '';
        for (var i = 0; i < this.value.length; i++) {
            displayValue +=
                (i != 0 ? this.separator + ' ' : '') + Ext.util.Format.htmlDecode(this.value[i].get(this.displayField));
        }
        return displayValue;
    },

    onRealBlur: function() {
        this.list.hide();
    },

    expand: function() {
        if (!this.storeRefreshed) {
            var snapshot = this.store.snapshot || this.store.data;
            if (!Ext.isArray(this.value)) {
                this.value = new Array();
            }
            snapshot.each(function(r) {
                var isEditing = r.editing;
                r.editing = this.forbidEditingMode;
                r.set(
                    this.checkField,
                    this.value.indexOfUsing(function(value, i, values) {
                        return value.get('id') == r.get('id');
                    }) != -1
                );
                r.editing = isEditing;
            }, this);
            this.view.refresh();
            this.storeRefreshed = true;
        }

        mx.comp.LinkedLovCombo.superclass.expand.call(this);
    },
    onSelect: function(record, index, skipCollapse) {
        if (skipCollapse) {
            this.lastSelectedIndex = index + 1;
            this.fireEvent('select', this, record, index);
        } else if (this.fireEvent('beforeselect', this, record, index) !== false) {
            var isEditing = record.editing;
            record.editing = this.forbidEditingMode;
            record.set(this.checkField, !record.get(this.checkField));
            record.editing = isEditing;
            this.setValue(record);
            this.view.refresh();
            this.fireEvent('select', this, record, index);
            this.dirty = true;
        }
    },

    onBeforeQuery: function(qe) {},
    clearValue: function() {
        this.setRawValue('');
        if (this.hiddenField) {
            this.hiddenField.value = '';
        }
        this.value = new Array();
        this.applyEmptyText();
        delete this.storeRefreshed;
    },
    isDirty: function() {
        return this.dirty;
    },
    transformValue: function(v) {
        return v;
    },
});

Ext.reg('mx-linkedlovcombo', mx.comp.LinkedLovCombo);
